const PHOTOS = 'https://excellentcareclinics.nl/wp-content/uploads/2023/05';

export interface TeamMember {
  name: string;
  role: string;
  /** Portrait from the current website, where available. */
  photo?: string;
}

export interface TeamGroup {
  title: string;
  members: TeamMember[];
}

/** From the current Over ons subpages. */
export const team: TeamGroup[] = [
  {
    title: 'Pijnspecialisten',
    members: [
      { name: 'Drs. K. Vos', role: 'Pijnspecialist / bestuur', photo: `${PHOTOS}/karinvosecc.png` },
      { name: 'Drs. C.J. Oostwouder', role: 'Pijnspecialist / bestuur', photo: `${PHOTOS}/ceesjanecc.png` },
      { name: 'Drs. H. de Gast', role: 'Pijnspecialist / medisch manager', photo: `${PHOTOS}/haikoecc.png` },
      { name: 'Drs. J. Teodorczyk', role: 'Pijnspecialist' },
      { name: 'Drs. L. Tjoa', role: 'Pijnspecialist' },
      { name: 'Drs. M. Verbeek', role: 'Pijnspecialist' },
      { name: 'Drs. T. Efthymiou', role: 'Pijnspecialist' },
    ],
  },
  {
    title: 'Pijnconsulenten',
    members: [
      { name: 'S. Ebbelaar', role: 'Pijnconsulente / teamleider verpleegkundige' },
      { name: 'S. Mol', role: 'Pijnconsulente / verpleegkundig specialist i.o.', photo: `${PHOTOS}/sandramolecc.png` },
      { name: 'K. van Oorschot', role: 'Pijnconsulente' },
      { name: 'M. Brantjes', role: 'Pijnconsulente i.o.' },
      { name: 'K. Borst', role: 'Pijnconsulente i.o.' },
    ],
  },
  {
    title: 'Verpleegkundigen',
    members: [
      { name: 'H. van Houts', role: 'Verpleegkundige' },
      { name: 'A. Mooij', role: 'Verpleegkundige' },
      { name: 'K. Schoorl', role: 'Verpleegkundige' },
      { name: 'M. Hoogeveen', role: 'Verpleegkundige' },
      { name: 'L. Verhagen-Schol', role: 'Verpleegkundige' },
      { name: 'R. Wouters', role: 'Verpleegkundige' },
      { name: 'S. Drent', role: 'Verpleegkundige' },
    ],
  },
  {
    title: 'Secretariaat',
    members: [
      { name: 'B. Meijer-Roemer', role: 'Secretariaat', photo: `${PHOTOS}/brenda-meijerecc.png` },
      { name: 'E. Groenland', role: 'Secretariaat' },
      { name: 'M. Oostwouder', role: 'Secretariaat' },
      { name: 'M. Pauwels', role: 'Secretariaat' },
      { name: 'S. Kooiman', role: 'Secretariaat' },
      { name: 'A. Appelman', role: 'Secretariaat' },
      { name: 'P. Karel', role: 'Secretariaat' },
      { name: 'A. de Bie', role: 'Secretariaat' },
      { name: 'C. van de Peet', role: 'Doktersassistent' },
    ],
  },
  {
    title: 'Management & financiën',
    members: [
      { name: 'M. de Ruyter', role: 'Management', photo: `${PHOTOS}/miriamecc.png` },
      { name: 'L. van Langen', role: 'Financiën' },
      { name: 'M. Burger', role: 'Financiën' },
      { name: 'M. Bras', role: 'Financiën' },
      { name: 'S. Kapitulska', role: 'Financiën' },
    ],
  },
];
